/* eslint-disable react/require-default-props */
import React from 'react';
// import { FiFileText } from 'react-icons/fi';

function ApplyNowHeader(
  { resumeName, candidateName = '' }: { resumeName: string | null, candidateName?: string | null },
) {
  return (
    <>
      <h2 className="my-0 py-0 font-bold text-2xl text-center">
        Screening -
        {' '}
        {' '}
        <span>{candidateName || resumeName}</span>
      </h2>
      {/* <section className="mb-3">
        <h2 className="mb-2 font-semibold text-lg">Your Resume</h2>
        <div className="border-[#2065EC] border-2 bg-[#2065EC]/10 p-2 border-dashed rounded-lg">
          <div className="flex items-center space-x-2 bg-white p-2 rounded-lg">
            <FiFileText className="w-6 h-6 text-blue-500" />
            <span className="text-gray-600 text-sm">{resumeName}</span>
          </div>
        </div>
      </section> */}
    </>
  );
}

export default ApplyNowHeader;
